import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Icon from '@material-ui/core/Icon';
import classnames from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { ADMIN_AGG_TRACKS_MONTHLY_LEGEND } from '../../../constants/legends';
import * as V from '../../../constants/variables';
import styles from '../FilterSidebar.module.css';

const H3_ZOOMS = [ 6, 7, 8, 9, 10, 11, 12, 'auto' ];
// как в v2: только all/scooters/bikes (без tandem)
const VEHICLE_TYPES = [
    { value: 'all',      label: V.aggregatedTracksFilterValues[0].label },
    { value: 'scooters', label: V.aggregatedTracksFilterValues[1].label },
    { value: 'bikes',    label: V.aggregatedTracksFilterValues[3].label },
];
const PERIOD_TYPES = V.aggregatedTracksDayFilterValues;
const AdminAggTracksMonthlyFilterComponent = ({
    onChangeMapFilters,
    adminAggTracksMonthlyH3Zoom,
    adminAggTracksMonthlyVehicleType,
    adminAggTracksMonthlyPeriod,
}) => {
    const [ isH3ZoomExpanded, setIsH3ZoomExpanded ] = useState(false);
    const handleH3ZoomChange = ({ target: { value } }) => {
        onChangeMapFilters('adminAggTracksMonthlyH3Zoom', value);
    };
    const handleVehicleTypeChange = ({ target: { value } }) => {
        onChangeMapFilters('adminAggTracksMonthlyVehicleType', value);
    };
    const handlePeriodChange = ({ target: { value } }) => {
        onChangeMapFilters('adminAggTracksMonthlyPeriod', value);
    };
    const toggleH3Zoom = () => setIsH3ZoomExpanded(!isH3ZoomExpanded);

    return (
        <div>
            <div className={styles.legHead}>{t`Агрегированные поездки`}:</div>
            <StandardRadioGroup
                value={adminAggTracksMonthlyVehicleType}
                onChange={handleVehicleTypeChange}
            >
                {
                    VEHICLE_TYPES.map(({ value, label }) => (
                        <FormControlLabel
                            key={value}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={adminAggTracksMonthlyVehicleType === value}
                                    onChange={handleVehicleTypeChange}
                                    value={value}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: adminAggTracksMonthlyVehicleType === value,
                                        }
                                    )}
                                    size="small"
                                />
                            }
                            label={i18n._(label)}
                            labelPlacement="end"
                        />
                    ))
                }
            </StandardRadioGroup>

            <div className={styles.legHead}>{t`Период`}:</div>
            <StandardRadioGroup
                value={adminAggTracksMonthlyPeriod}
                onChange={handlePeriodChange}
            >
                {
                    PERIOD_TYPES.map(({ value, label }) => (
                        <FormControlLabel
                            key={value}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={adminAggTracksMonthlyPeriod === value}
                                    onChange={handlePeriodChange}
                                    value={value}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: adminAggTracksMonthlyPeriod === value,
                                        }
                                    )}
                                    size="small"
                                />
                            }
                            label={i18n._(label)}
                            labelPlacement="end"
                        />
                    ))
                }
            </StandardRadioGroup>

            <div
                className={classnames(styles.legHead, {
                    [styles.expandableLegHead]: true,
                    [styles.expandableLegHeadOpen]: isH3ZoomExpanded,
                })}
                onClick={toggleH3Zoom}
                style={{ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center' }}
            >
                {t`H3 Zoom`}:
                <Icon style={{ marginLeft: 'auto', transition: 'transform 0.25s ease' }}>expand_more</Icon>
            </div>
            {isH3ZoomExpanded && (
                <StandardRadioGroup
                    value={String(adminAggTracksMonthlyH3Zoom)}
                    onChange={handleH3ZoomChange}
                >
                    {
                        H3_ZOOMS.map(zoom => (
                            <FormControlLabel
                                key={zoom}
                                className={styles.isochroneFilterLabel}
                                control={
                                    <Radio
                                        checked={String(adminAggTracksMonthlyH3Zoom) === String(zoom)}
                                        onChange={handleH3ZoomChange}
                                        value={String(zoom)}
                                        className={classnames(
                                            styles.isochroneFilterInput, {
                                                [styles.checkedIsochroneFilterInput]: String(adminAggTracksMonthlyH3Zoom) === String(zoom),
                                            }
                                        )}
                                        size="small"
                                    />
                                }
                                label={zoom}
                            />
                        ))
                    }
                </StandardRadioGroup>
            )}

            <LegendRenderer config={ADMIN_AGG_TRACKS_MONTHLY_LEGEND} />
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { adminAggTracksMonthlyH3Zoom, adminAggTracksMonthlyVehicleType, adminAggTracksMonthlyPeriod } }) => ({
    adminAggTracksMonthlyH3Zoom,
    adminAggTracksMonthlyVehicleType,
    adminAggTracksMonthlyPeriod,
});
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(AdminAggTracksMonthlyFilterComponent);

export const AdminAggTracksMonthlyFilter = withDisplayedLayersCheck(
    ConnectedComponent,
    t`Агрегированные треки за месяц`
);
